import { Link } from 'react-router-dom';
import styles from './Logo.module.css';
import LogoSVG from './Logo.svg';
const Logo = (props)=>{
    return (
        <Link to="/home" className={styles.Logo}><img src={LogoSVG} alt="FlatEarth Logo" /></Link>
    )
}

export default Logo;